
import { WarningToast } from "../Components/ToastComponent/RectHotToast";

export function checkFormErrors(data) {
  let alertDisplayed = false;
  let notification = null;

  const hasValue = (value) =>
    value !== undefined && value !== null && value !== "";

  const replaceUnderscore = (text) =>
    text ? text.replaceAll("_", " ") : "";

  const checkNested = (obj) => {
    for (const key in obj) {
      const value = obj[key];

      if (typeof value === "object" && value !== null && !Array.isArray(value)) {
        // Check if this object has "error" and "id" fields (new format)
        if (value.error && hasValue(value.error)) {
          if (!alertDisplayed) {
            WarningToast(`Error: ${value.error}`);
            if (value.id) {
              const input = document.getElementById(value.id);
              if (input) input.focus();
            } else {
              const input = document.getElementsByName(key);
              if (input.length > 0) {
                input[input.length - 1].focus();
              }
            }
            notification = `Error: ${value.error}`;
            alertDisplayed = true;
          }
        } else {
          // Recursively check nested objects
          checkNested(value);
        }
      } else {
        // Old format: key: "Error message"
        if (hasValue(value) && !alertDisplayed) {
          WarningToast(`Error: ${replaceUnderscore(value)}`);
          const input = document.getElementsByName(key);
          if (input.length > 0) {
            input[input.length - 1].focus();
          }
          notification = `Error: ${key} is ${value}`;
          alertDisplayed = true;
        }
      }

      if (alertDisplayed) break;
    }
  };

  checkNested(data);
  return notification;
}
